import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { srOnly } from '../../styles/focus';

export const OpensInNewTab = () => {
  const { t } = useTranslation();

  return (
    <Box component='span' sx={srOnly}>
      {t('accessibility.opensInNewTab')}
    </Box>
  );
};
